import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import backIcon from "../Assets/common/back.svg";
import { ZustandStore } from "../../store/zustand-store";
import FallbackLoader from "../share/components/FallbackLoader";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { motion, AnimatePresence } from "framer-motion";
import { features, pricingModes } from "../dataFiles/pricing-data";

import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";

const Upgrade = () => {
  const [value, setValue] = useState(0);
  const email = useSelector((state) => state.email);
  const { plan_loaded, customer_plan } = ZustandStore((state) => state);
  const isSubscribe = customer_plan?.user_type === "subscription";

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const scriptId = `stripe-script-upgrade`;
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://js.stripe.com/v3/pricing-table.js";
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      const script = document.getElementById(scriptId);
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const mode = value === 1 ? "yearly" : "monthly";
  const plans = pricingModes[mode].plans;

  const handleBillingPortal = () => {
    const manage_plan_link = `https://billing.stripe.com/p/login/14k7us0IvchS8so6oo?prefilled_email=${email}`;
    window.open(manage_plan_link, "_blank");
  };
  return (
    <Box className="py-4">
      <Box className="mb-2 upgrade-money-back-cont">
        <Link to={-1} className="d-flex me-auto" style={{ width: "80px" }}>
          <button className="icon-btn large-btn">
            <img src={backIcon} alt="back button" className="me-1" /> Back
          </button>
        </Link>
        {/* <Box className="strap">
          <Box
            style={{
              background:
                "linear-gradient(90deg, #6254FF 0%, #E95655 52.4%, #6254FF 100%)",
            }}
            className="py-1 text-white text-center strap-line"
          >
            <Typography>“48 HOURS MONEY BACK GUARANTEE”</Typography>
          </Box>
        </Box> */}
      </Box>

      {!plan_loaded ? (
        <FallbackLoader />
      ) : isSubscribe ? (
        <Box
          className="profile-det d-flex flex-column align-items-center m-auto"
          style={{ maxWidth: "1060px" }}
        >
          <Box className="ProfileBox flex-column text-start align-items-start p-3 my-4 w-100">
            <h4 className="profile-heading mb-2">Manage Your Subscription</h4>
            <p>
              Your account is enrolled in an active paid plan. You may manage
              your subscription, including billing and plan changes.
            </p>
            <button
              className="pr-buy-btn px-2 mt-2 ms-auto"
              style={{ backgroundColor: "#E95757" }}
              onClick={handleBillingPortal}
            >
              Manage Subscription
            </button>
          </Box>
          <Tabs
            value={value}
            onChange={handleChange}
            label="Default"
            aria-label="default"
            id="plan_list"
            sx={{
              borderRadius: "0.6rem",
              width: "241px",
              height: "42px",
              minHeight: "42px",
              alignItems: "center",
              border: "1px solid #1a1a1a1a",
              backgroundColor: "#1a1a1a0d",
              "& .MuiTabs-indicator": {
                height: 0,
              },
              "& .MuiTab-root.Mui-selected": {
                color: "white",
                backgroundColor: "#7542ff",
                border: "1px solid #7542ff",
              },
              "& .MuiTab-root": {
                border: "1px solid transparent",
                height: "36px",
                width: "118px",
                minHeight: "36px",
                textTransform: "capitalize",
                fontWeight: "400",
                fontSize: "14px",
                fontFamily: "Lato",
              },
              "& .MuiButtonBase-root": {
                backgroundColor: "transparent",
                color: "#191B23",
              },
            }}
          >
            <Tab
              label="Monthly"
              aria-label="monthly"
              sx={{
                borderRadius: "0.5rem",
              }}
            />
            <Tab
              label="Yearly"
              aria-label="yearly"
              sx={{
                borderRadius: "0.5rem",
              }}
            />
          </Tabs>
          <div className="w-100 upgrade-comparison-table mt-4">
            <div className="overflow-x-auto">
              <AnimatePresence mode="wait">
                <motion.table
                  key={mode}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                >
                  <thead className="bg-gray-100 text-gray-700">
                    <tr>
                      <th className="p-3 font-semibold">
                        Features / Plans Type
                      </th>
                      {plans.map((plan, idx) => (
                        <th key={idx} className="p-3 text-center font-semibold">
                          <span>{plan.title}</span>{" "}
                          <span className="plan-price">({plan.price})</span>
                          {plan.sub && (
                            <div className="plan-sub">{plan.sub}</div>
                          )}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="text-gray-800">
                    {features.map((feature, idx) => (
                      <tr key={idx} className="">
                        <td className="p-3 font-medium">{feature.name}</td>
                        {feature.values.map((val, i) => (
                          <td key={i} className="p-3 text-center">
                            {typeof val === "boolean" ? (
                              val ? (
                                <CheckIcon sx={{ color: "#007F00" }} />
                              ) : (
                                <ClearIcon sx={{ color: "#A00000" }} />
                              )
                            ) : (
                              val
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </motion.table>
              </AnimatePresence>
            </div>
          </div>
        </Box>
      ) : (
        <stripe-pricing-table
          data-rewardful
          pricing-table-id="prctbl_1QpT0EEqzk39wvISlpI2FbHV"
          publishable-key="pk_live_51J9qcJEqzk39wvISC6PehnilAyKlutXNCaJiojSgd4U0O0j0k6bLMGkf8EHpxX2HENmRaRzEJEmXhvdjhHSXd3tU002Coo9dry"
          customer-email={email}
        ></stripe-pricing-table>
      )}
    </Box>
  );
};

export default Upgrade;
